import { GlobalBaseLocation } from '../../models/global-base-location';

export class State extends GlobalBaseLocation {
}
